var _rect, _rect2, _rect3, _path, _circle, _circle2, _circle3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path2, _path3, _rect10, _circle4, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 124,
    viewBox: "0 0 151 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.605,
    y: 112.598,
    width: 34.252,
    height: 12.802,
    rx: 6.401,
    transform: "rotate(-30 25.605 112.598)",
    fill: "#E6E6E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.363,
    y: 78.188,
    width: 17.051,
    height: 12.788,
    rx: 6.394,
    transform: "rotate(-30 8.363 78.188)",
    fill: "#E6E6E6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 107.126,
    y: 6.402,
    width: 12.802,
    height: 12.802,
    rx: 6.401,
    transform: "rotate(-30 107.126 6.402)",
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.564 49.45a6.401 6.401 0 106.401 11.086l3.72-2.147-.027.016 3.904-2.254a6.401 6.401 0 016.453 11.056l47.787-27.59c.502-.29.95-.637 1.341-1.03a6.404 6.404 0 01-6.179-10.703 6.407 6.407 0 00-1.538.632l2.861-1.652.018-.01.858-.496a6.401 6.401 0 00-6.419-11.076l-59.18 34.167zm10.562 23.467l.038-.022 9.799-5.657.038-.022 63.587-36.712a6.401 6.401 0 016.401 11.087L95.195 57.638c.076-.043.152-.085.23-.125a6.401 6.401 0 006.388 11.078 6.703 6.703 0 01-.251.153L70.563 86.642a6.401 6.401 0 00-6.46-11.053l-8.649 4.993.025-.014-11.347 6.551a6.401 6.401 0 01-6.401-11.087l5.395-3.115zm26.666 14.17a6.401 6.401 0 006.452 11.057l47.506-27.427a6.402 6.402 0 00-6.357-11.112l-15.316 8.842-.045.026-31.477 18.173-.05.03-.713.411z",
    fill: "#E6E6E6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 143.509,
    cy: 75.449,
    r: 2.818,
    stroke: "#E6E6E6",
    strokeWidth: 2.605
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.439,
    cy: 32.963,
    r: 1.965,
    stroke: "#E6E6E6",
    strokeWidth: 2.605
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.619,
    cy: 113.956,
    r: 1.965,
    stroke: "#E6E6E6",
    strokeWidth: 2.605
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 91.079,
    y: 3.27,
    width: 7.957,
    height: 1.421,
    rx: 0.71,
    fill: "#E6E6E6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 95.768,
    width: 7.957,
    height: 1.421,
    rx: 0.71,
    transform: "rotate(90 95.768 0)",
    fill: "#E6E6E6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 118.646,
    y: 94.703,
    width: 5.968,
    height: 1.421,
    rx: 0.71,
    fill: "#E6E6E6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 122.34,
    y: 92.5,
    width: 5.968,
    height: 1.421,
    rx: 0.71,
    transform: "rotate(90 122.34 92.5)",
    fill: "#E6E6E6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 5.399,
    y: 65.859,
    width: 5.968,
    height: 1.421,
    rx: 0.71,
    fill: "#E6E6E6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 9.094,
    y: 63.656,
    width: 5.968,
    height: 1.421,
    rx: 0.71,
    transform: "rotate(90 9.094 63.656)",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.252 37.273c-10.076 10.103-10.076 26.482 0 36.584l13.397 13.434a6.848 6.848 0 009.702 0l13.397-13.433c10.076-10.103 10.076-26.482 0-36.585-10.078-10.104-26.418-10.104-36.496 0zm18.214 8.952c5.14 0 9.311 4.179 9.311 9.34 0 5.162-4.172 9.34-9.311 9.34-5.14 0-9.312-4.178-9.312-9.34 0-5.161 4.172-9.34 9.312-9.34z",
    fill: "#fff",
    stroke: "#AFAFAF",
    strokeWidth: 2.61
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72 87.978a5.533 5.533 0 004.427-1.609l13.397-13.433c9.568-9.594 9.568-25.148 0-34.74A24.394 24.394 0 0072 31.005V44.93c.154-.007.31-.01.466-.01 5.863 0 10.616 4.765 10.616 10.645 0 5.879-4.753 10.645-10.616 10.645-.156 0-.312-.004-.466-.01v21.777z",
    fill: "#ECECEC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 93.92,
    y: 76.662,
    width: 28.61,
    height: 4.61,
    rx: 2.305,
    transform: "rotate(45 93.92 76.662)",
    fill: "#ECECEC",
    stroke: "#AFAFAF",
    strokeWidth: 2.61
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.213,
    cy: 79.215,
    r: 13.695,
    transform: "rotate(-45 93.213 79.215)",
    fill: "#fff",
    stroke: "#AFAFAF",
    strokeWidth: 2.61
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101 79a8 8 0 00-8-8",
    stroke: "#AFAFAF",
    strokeWidth: 2.61,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFound);
export default __webpack_public_path__ + "static/media/no-found.1bb29ace.svg";
export { ForwardRef as ReactComponent };